var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overview"},[_c('v-card-title',{staticClass:"overview__title"},[_vm._v(" "+_vm._s(_vm.$t('labels.overview'))+" ")]),_c('p',{staticClass:"px-lg-1"},[_vm._v(" "+_vm._s(_vm.$t('preferences.shipmentsOverview'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }